import { createSlice } from "@reduxjs/toolkit";
import IUserStore from "../interfaces/IUserStore";


const initUser: IUserStore = {
    email: '',
    iduser: 0,
    user: '',
    role: 0,
    token: '',
    auth: false,
    company: null
}

export const userSlice = createSlice({
    name: "user",
    initialState: {
        user: initUser,
    },
    reducers: {
        login: (state, action) => {
            state.user = action.payload;
            localStorage.setItem('IbToken', action.payload.token)
        },
        logout: (state) => {
            state.user = initUser;
            localStorage.removeItem('IbToken')
        }
    }
})
// eslint-disable-next-line
export const selectUser = (state: any) => state.user.user
export const { login, logout } = userSlice.actions
export default userSlice.reducer